import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  ErrorStateMatcher,
  JbCloseButtonModule,
  JbContextualHelpModule,
  JbDatePickerModule,
  JbErrorModule,
  JbFormFieldContainerModule,
  JbIconModule,
  JbInputModule,
  JbRadioModule,
  JbSelectModule,
  ShowOnSubmitErrorStateMatcher,
} from 'jb-component-library';

import { DialogTempModule } from '../../shared/dialog';
import { UIModule } from '../../shared/ui';
import {
  ContactUsReceiptComponent,
  contactUsReceiptContainerResolver,
} from './contact-us-receipt.component';

const MODULES = [
  ReactiveFormsModule,
  DialogTempModule,
  UIModule,
  JbCloseButtonModule,
  CommonModule,
  JbDatePickerModule,
  JbIconModule,
  JbInputModule,
  JbSelectModule,
  JbRadioModule,
  JbFormFieldContainerModule,
  JbErrorModule,
  JbContextualHelpModule,
  FormsModule,
];
const DECLARATIONS = [ContactUsReceiptComponent];

@NgModule({
  declarations: [...DECLARATIONS],
  imports: [...MODULES],
  exports: [...DECLARATIONS, ...MODULES],
  providers: [
    { provide: ErrorStateMatcher, useClass: ShowOnSubmitErrorStateMatcher },
  ],
})
export class ContactUsReceiptModule {
  static entry = ContactUsReceiptComponent;
  static componentDataResolver = contactUsReceiptContainerResolver;
}
